// extracted by mini-css-extract-plugin
export default {"mark1":"Hero_mark1__LeCck","mark2":"Hero_mark2__EsSui"};